// What a deal form shows of a refused save (dealForm.js refusedSave), held the same way by the
// form (DealForm.jsx) and by the deal's page (DealStageForm.jsx): the refusal above the form,
// with whether a reload answers it, and the field errors beside their fields.

import { useCallback, useState } from 'react';

import { refusedSave } from './dealForm.js';

export function useSaveRefusal() {
  // { message, stale } or null.
  const [refusal, setRefusal] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});

  const refuse = useCallback((err, draft, vocabulary) => {
    const shown = refusedSave(err, draft, vocabulary);
    setRefusal(shown.error ? { message: shown.error, stale: shown.stale } : null);
    setFieldErrors(shown.fieldErrors);
  }, []);

  // Before a save: the form's own refusals, and nothing left over from the last answer.
  const refuseFields = useCallback((errors) => {
    setRefusal(null);
    setFieldErrors(errors);
  }, []);

  return { refusal, setRefusal, fieldErrors, refuse, refuseFields };
}
